// extracted by mini-css-extract-plugin
module.exports = {"container":"styling_container__Gtwh0","wrapper":"styling_wrapper__3X7pV","image":"styling_image__23316"};